export default __webpack_public_path__ + "static/media/srinivas sir.2f77809e.jpg";